import React, { useState } from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion
import PublicNavbar from '../components/PublicNavbar';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <motion.div
      className="border-b border-gray-200"
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      transition={{ duration: 0.3 }}
    >
      <button
        className="w-full text-left py-4 flex justify-between items-center focus:outline-none"
        onClick={onClick}
      >
        <span className="text-lg font-medium text-gray-800">{question}</span>
        <motion.svg
          className={`w-6 h-6 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </motion.svg>
      </button>
      {isOpen && (
        <motion.p
          className="pb-4 text-gray-600"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          {answer}
        </motion.p>
      )}
    </motion.div>
  );
};

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(prevIndex => (prevIndex === index ? null : index));
  };

  const faqs = [
    {
      question: "Como gerar meu mapa astral?",
      answer: "Para gerar seu mapa astral, você precisa fornecer sua data, hora e local de nascimento na página de geração de mapas."
    },
    {
      question: "Quais informações são necessárias para o mapa astral?",
      answer: "Você precisará informar sua data de nascimento, hora exata e local de nascimento para uma análise precisa."
    },
    {
      question: "Posso salvar meus mapas astrais?",
      answer: "Sim, na área de perfil você pode visualizar e gerenciar todos os seus mapas astrais gerados."
    },
    {
      question: "O serviço é gratuito?",
      answer: "Oferecemos planos gratuitos com funcionalidades básicas e planos pagos com recursos avançados."
    },
    // Adicione mais itens de FAQ conforme necessário
  ];

  return (
    <>
      <PublicNavbar />
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center p-4">
        <div className="bg-white shadow-xl rounded-lg max-w-3xl w-full p-8">
          <h1 className="text-4xl font-bold mb-8 text-center bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Perguntas Frequentes</h1>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <FAQItem
                key={index}
                question={faq.question}
                answer={faq.answer}
                isOpen={openIndex === index}
                onClick={() => handleToggle(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQPage;